import { memo } from 'react';
import { TextArea as RACTextArea, TextAreaProps as RACTextAreaProps } from 'react-aria-components';

import { merge } from '@/components';

export type TextAreaProps = RACTextAreaProps;

const ITextArea = ({ className, children, ...rest }: TextAreaProps) => {
  /* prettier-ignore */
  const styles = [
    'bg-white',
    'border',
    'border-gray-200',
    'outline-none',
    'px-sm',
    'py-[0.35rem]',
    'rounded-md',
    'text-sm',
  ];
  /* prettier-ignore */
  const lightStyles = [
    'placeholder:text-gray-400',
  ];

  return (
    <RACTextArea className={merge(styles, lightStyles, className)} {...rest}>
      {children}
    </RACTextArea>
  );
};

export const TextArea = memo(ITextArea) as typeof ITextArea;
